export default {
  name: 'app-footer',
  methods: {
    goKisoku: function() {
      this.$store.dispatch('GO_KISOKU')
    },
    goYeswecan: function() {
      this.$store.dispatch('GO_YESWECAN')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/app-footer.js